import { render, staticRenderFns } from "./ajTable.vue?vue&type=template&id=895b36fe&scoped=true"
import script from "./ajTable.vue?vue&type=script&lang=js"
export * from "./ajTable.vue?vue&type=script&lang=js"
import style0 from "./ajTable.vue?vue&type=style&index=0&id=895b36fe&prod&scoped=true&lang=css"
import style1 from "./ajTable.vue?vue&type=style&index=1&id=895b36fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895b36fe",
  null
  
)

export default component.exports